import { I18nextProvider } from 'react-i18next';

/**
 * Thin wrapper so apps import i18n wiring only from @aimsos/i18n.
 */
export function I18nProvider({ i18n, children }) {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
